import { server } from './config'
import client from './client'

export default {
  getCountryStates(data = {}, config = {}) {
    return client.get(`${server}/checkin/api/states?country_id=${data}`)
  }
}
